module.exports = __webpack_public_path__ + "static/media/cross-light-grey.10ea7ca4.svg";